import select2 from 'select2/dist/js/select2.full';

export { select2 };
